module.exports = __webpack_public_path__ + "img/banner-illustration.086c8c1a.png";